export function useFormatting() {
    return {
        formatMoney: (amount: number) => amount.toString().replace(new RegExp(`(^\\d{${amount.toString().length % 3 || -1}})(?=\\d{3})`), '$1' + '.').replace(/(\d{3})(?=\d)/g, '$1' + '.'),
    };
}
